import React from 'react';
import { Button, Text } from "../../Atoms";
import { COLOR_BUTTON } from "../../Config/Config";
import { IconTitleMolecule } from '../../Molecules';
import { Link } from 'react-router-dom';

const TemplateErreurPrelevement = () => {  
  return (
    <div className="template-scroll template-container cotisations mt-20 d-flex flex-column">
      <div className="content-large-max">
        <IconTitleMolecule
          text="Désolé, une erreur est apparue lors de l'enregistrement de votre demande de prélèvement!"
          className="title-page font-title mt-40"
          icon="alert-error"
          size='icon-x2'
        />
        <Text
          text="Veuillez renouveller votre demande ultérieurement ou nous contacter."
          type="h8"
          className="mt-20"
        />
        <Text
          text="Merci de votre confiance et à bientôt sur CGRM!"
          type="h8"
          className="mt-20"
        />
 
        <div className="mt-40 text-center">
          <div className="text-center">
            <Link to="/" >
              <Button
                text="Retour à l'accueil de CGRM"
                className="button-red-rounded"
                color={COLOR_BUTTON.SECOND_RED}
              />
            </Link>
          </div>
        </div>
      </div>      
    </div>
  );
}

export default TemplateErreurPrelevement;
